const galleryItems = [
  {
    title: 'Dragon Sculpture',
    category: 'Art Piece',
    image: 'https://public.readdy.ai/ai/img_res/6a24c743d06e44ee6c88f3609a675c13.jpg',
    tall: true,
  },
  {
    title: 'Mechanical Prototype',
    category: 'Prototyping',
    image: 'https://readdy.ai/api/search-image?query=3D%20printed%20mechanical%20gear%20assembly%20prototype%2C%20grey%20and%20white%20PLA%20parts%2C%20engineering%20precision%20component%20on%20clean%20white%20surface%2C%20technical%20product%20photography%2C%20professional%20studio%20lighting&width=600&height=400&seq=gallery-002&orientation=landscape',
    tall: false,
  },
  {
    title: 'Custom Vase',
    category: 'Home Decor',
    image: 'https://readdy.ai/api/search-image?query=elegant%203D%20printed%20geometric%20vase%20with%20intricate%20lattice%20pattern%2C%20white%20and%20gold%20filament%2C%20modern%20minimalist%20home%20decor%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20product%20photography&width=600&height=400&seq=gallery-003&orientation=landscape',
    tall: false,
  },
  {
    title: 'Fantasy Miniatures',
    category: 'Miniatures',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20detailed%203D%20printed%20fantasy%20miniature%20figures%2C%20painted%20warriors%20and%20creatures%2C%20tabletop%20gaming%20pieces%20on%20wooden%20surface%2C%20macro%20photography%2C%20dramatic%20moody%20lighting&width=600&height=700&seq=gallery-004&orientation=portrait',
    tall: true,
  },
  {
    title: 'Custom Nameplate',
    category: 'Personalized Gift',
    image: 'https://readdy.ai/api/search-image?query=3D%20printed%20custom%20name%20sign%20with%20decorative%20letters%2C%20colorful%20rainbow%20filament%20spelling%20a%20name%2C%20gift%20item%20on%20wooden%20table%2C%20warm%20cozy%20background%2C%20lifestyle%20photography&width=600&height=400&seq=gallery-005&orientation=landscape',
    tall: false,
  },
  {
    title: 'Architectural Model',
    category: 'Prototype',
    image: 'https://readdy.ai/api/search-image?query=detailed%203D%20printed%20architectural%20scale%20model%20of%20a%20modern%20house%2C%20white%20PLA%20material%2C%20precise%20miniature%20building%20model%20on%20display%20table%2C%20professional%20photography%2C%20clean%20background&width=600&height=400&seq=gallery-006&orientation=landscape',
    tall: false,
  },
  {
    title: 'Cosplay Armor',
    category: 'Custom Design',
    image: 'https://readdy.ai/api/search-image?query=3D%20printed%20cosplay%20armor%20pieces%2C%20detailed%20sci-fi%20chest%20plate%20and%20shoulder%20armor%2C%20metallic%20silver%20and%20black%20filament%2C%20dramatic%20studio%20lighting%2C%20dark%20background%2C%20impressive%20prop&width=600&height=700&seq=gallery-007&orientation=portrait',
    tall: true,
  },
  {
    title: 'Phone Stand',
    category: 'Functional Part',
    image: 'https://readdy.ai/api/search-image?query=sleek%203D%20printed%20phone%20stand%20desk%20accessory%2C%20modern%20geometric%20design%20in%20vibrant%20orange%20filament%2C%20clean%20white%20desk%20setup%2C%20product%20photography%2C%20minimal%20background&width=600&height=400&seq=gallery-008&orientation=landscape',
    tall: false,
  },
];

export default function GallerySection() {
  return (
    <section id="gallery" className="py-24 px-6 md:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs uppercase tracking-[3px] font-bold bg-gradient-to-r from-cyan-500 to-fuchsia-500 bg-clip-text text-transparent">
            Portfolio
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mt-3">Our Creations</h2>
          <p className="text-gray-500 mt-4 text-base max-w-md mx-auto">From concept to reality — a glimpse of what we&apos;ve built for our clients.</p>
        </div>

        {/* Masonry-style Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-4 gap-4 space-y-4">
          {galleryItems.map((item, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-2xl cursor-pointer break-inside-avoid"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                style={{ height: item.tall ? '320px' : '200px' }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <span className="text-xs text-fuchsia-300 font-semibold uppercase tracking-wider">{item.category}</span>
                <h3 className="text-white font-bold text-base mt-1">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
